import { Mixpanel } from 'utils/mixpanel'

import { EVENTS } from './events'

export const MIXPANEL_NORMALIZED_EVENTS = {
  [EVENTS.PRICE_PAGE_VIEW]: Mixpanel.trackPricingPageView,
  [EVENTS.PURCHASE_CLICK]: Mixpanel.trackPurchaseClick,
  [EVENTS.SIGN_UP_PAGEVIEW]: Mixpanel.trackSignUpPageview,
  [EVENTS.SIGN_IN_PAGEVIEW]: Mixpanel.trackSignInPageView,
  [EVENTS.SIGN_IN_SUCCESS]: Mixpanel.trackSignInSuccess,
  [EVENTS.SIGN_UP_SUCCESS]: Mixpanel.trackSignUpSuccess,
  [EVENTS.PLAN_SELECT_CLICK]: Mixpanel.trackPlanSelectClick,
  [EVENTS.CHECKOUT_VIEW]: Mixpanel.trackCheckoutView,
  [EVENTS.NEW_CHECKOUT_MODAL_VIEW]: Mixpanel.trackNewCheckoutModalView,
  [EVENTS.PAYMENT_SELECT_CLICK]: Mixpanel.trackPaymentSelectClick,
  [EVENTS.PAYMENT_SUBMIT_CLICK]: Mixpanel.trackPaymentSubmitClick,
  [EVENTS.CHECKOUT_SUCCESS]: Mixpanel.trackCheckoutSuccess,
  [EVENTS.CHECKOUT_ERROR]: Mixpanel.trackCheckoutError,
  [EVENTS.ATP_CROSS_SELL_MODAL_CLICK]: Mixpanel.trackAtpCrossSellModalClick,
  [EVENTS.BUY_ADDON_CLICK]: Mixpanel.trackBuyAddonClick,
  [EVENTS.UNLOADED_REPORT_VIEW]: Mixpanel.trackUnloadedReportView,
  [EVENTS.LOADED_REPORT_VIEW]: Mixpanel.trackLoadedReportView,
  [EVENTS.PROJECT_CREATION_CLICK]: Mixpanel.trackProjectCreationClick,
  [EVENTS.PROJECT_CREATION_SUCCESS]: Mixpanel.trackProjectCreationSuccess,
  [EVENTS.CANCEL_SUBSCRIPTION_SUCCESS]: Mixpanel.trackCancelSubscriptionSuccess,
  [EVENTS.PROJECT_CREATION_SUCCESS_MODAL_CLICK]:
    Mixpanel.trackProjectCreationSuccessModalClick,
  [EVENTS.START_TRIAL]: Mixpanel.trackCheckoutSuccess,
  [EVENTS.PLAIN_FILTER_CLICK]: Mixpanel.trackPlainFilterClick,
  [EVENTS.COPY_SUCCESS]: Mixpanel.trackCopySuccess,
  [EVENTS.EXPORT_SUCCESS]: Mixpanel.trackExportSuccess,
} as const
